import { render, staticRenderFns } from "./GalleryEditor.vue?vue&type=template&id=e0fa70fa&scoped=true"
import script from "./GalleryEditor.vue?vue&type=script&lang=ts"
export * from "./GalleryEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fa70fa",
  null
  
)

export default component.exports